module.exports = __webpack_public_path__ + "needumomtext2white.svg?8e98c438f697bf629496823fb529981c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/needumomtext2white.svg
// module id = 343
// module chunks = 0